/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiFacultyItemIdGet } from '../fn/faculty/api-faculty-item-id-get';
import { ApiFacultyItemIdGet$Params } from '../fn/faculty/api-faculty-item-id-get';
import { apiFacultyOverviewGet } from '../fn/faculty/api-faculty-overview-get';
import { ApiFacultyOverviewGet$Params } from '../fn/faculty/api-faculty-overview-get';
import { apiFacultySyncPost } from '../fn/faculty/api-faculty-sync-post';
import { ApiFacultySyncPost$Params } from '../fn/faculty/api-faculty-sync-post';
import { Faculty } from '../models/faculty';
import { FacultyOverviewList } from '../models/faculty-overview-list';
import { ImportResult } from '../models/import-result';


/**
 * Faculty service
 */
@Injectable({ providedIn: 'root' })
export class FacultyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiFacultyItemIdGet()` */
  static readonly ApiFacultyItemIdGetPath = '/api/faculty/{item_id}';

  /**
   * Get a faculty.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFacultyItemIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFacultyItemIdGet$Response(params: ApiFacultyItemIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Faculty>> {
    return apiFacultyItemIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a faculty.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFacultyItemIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFacultyItemIdGet(params: ApiFacultyItemIdGet$Params, context?: HttpContext): Observable<Faculty> {
    return this.apiFacultyItemIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Faculty>): Faculty => r.body)
    );
  }

  /** Path part for operation `apiFacultyOverviewGet()` */
  static readonly ApiFacultyOverviewGetPath = '/api/faculty/overview';

  /**
   * Get faculty overview.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFacultyOverviewGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFacultyOverviewGet$Response(params?: ApiFacultyOverviewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<FacultyOverviewList>> {
    return apiFacultyOverviewGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get faculty overview.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFacultyOverviewGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFacultyOverviewGet(params?: ApiFacultyOverviewGet$Params, context?: HttpContext): Observable<FacultyOverviewList> {
    return this.apiFacultyOverviewGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacultyOverviewList>): FacultyOverviewList => r.body)
    );
  }

  /** Path part for operation `apiFacultySyncPost()` */
  static readonly ApiFacultySyncPostPath = '/api/faculty/sync';

  /**
   * Sync faculties.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFacultySyncPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiFacultySyncPost$Response(params: ApiFacultySyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportResult>> {
    return apiFacultySyncPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync faculties.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFacultySyncPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiFacultySyncPost(params: ApiFacultySyncPost$Params, context?: HttpContext): Observable<ImportResult> {
    return this.apiFacultySyncPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImportResult>): ImportResult => r.body)
    );
  }

}
